const fetch = require("node-fetch");

export async function getLatLong(place) {
  let url = "https://us-central1-foncier-public.cloudfunctions.net/longLatMaps";

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      body: JSON.stringify({ address: encodeURI(place) })
    })
      .then(r => r.json())
      .then(r => {
        if (r.status == "FAILURE") {
          resolve({ status: "FAILURE" });
        } else {
          resolve({
            status: "SUCCESS",
            data: r.data.results[0].geometry.location
          });
        }
        resolve(r);
      })
      .catch(err => reject(err));
  });
}

export function computeDistance(origin, destination) {
  let url = "https://us-central1-foncier-public.cloudfunctions.net/getDistance";

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      body: JSON.stringify({ origin: origin, destination: destination })
    })
      .then(r => r.json())
      .then(r => resolve(r))
      .catch(err => reject(err));
  });
}
